import type { TranslationTable } from "@repo/shared/types";

const EN_GB = {
  million: "M",
  billion: "bn",
  today: "Today",
  tomorrow: "Tomorrow",
};

// All 17 locales (QL-17 plan keeps them); the type makes each one match EN_GB.
export const T: TranslationTable<typeof EN_GB> = {
  en_GB: EN_GB,
  fr_FR: {
    million: "M",
    billion: "Md",
    today: "Aujourd'hui",
    tomorrow: "Demain",
  },
  es_ES: {
    million: "M",
    billion: "mil M",
    today: "Hoy",
    tomorrow: "Mañana",
  },
  pt_BR: {
    million: "mi",
    billion: "bi",
    today: "Hoje",
    tomorrow: "Amanhã",
  },
  de_DE: {
    million: "Mio.",
    billion: "Mrd.",
    today: "Heute",
    tomorrow: "Morgen",
  },
  it_IT: {
    million: "mln",
    billion: "mld",
    today: "Oggi",
    tomorrow: "Domani",
  },
  ar: {
    million: "مليون",
    billion: "مليار",
    today: "اليوم",
    tomorrow: "غدًا",
  },
  ja_JP: {
    million: "百万",
    billion: "十億",
    today: "今日",
    tomorrow: "明日",
  },
  hi_IN: {
    million: "M",
    billion: "B",
    today: "आज",
    tomorrow: "कल",
  },
  zh_CN: {
    million: "百万",
    billion: "十亿",
    today: "今天",
    tomorrow: "明天",
  },
  zh_TW: {
    million: "百萬",
    billion: "十億",
    today: "今天",
    tomorrow: "明天",
  },
  nl_NL: {
    million: "mln",
    billion: "mld",
    today: "Vandaag",
    tomorrow: "Morgen",
  },
  nb_NO: {
    million: "mill.",
    billion: "mrd.",
    today: "I dag",
    tomorrow: "I morgen",
  },
  sv_SE: {
    million: "mn",
    billion: "md",
    today: "I dag",
    tomorrow: "I morgon",
  },
  fi_FI: {
    million: "milj.",
    billion: "mrd.",
    today: "Tänään",
    tomorrow: "Huomenna",
  },
  da_DK: {
    million: "mio.",
    billion: "mia.",
    today: "I dag",
    tomorrow: "I morgen",
  },
  is_IS: {
    million: "millj.",
    billion: "ma.",
    today: "Í dag",
    tomorrow: "Á morgun",
  },
};
